import { render, staticRenderFns } from "./SyntheticMonitoringDashboard.vue?vue&type=template&id=dcf5544c&"
import script from "./SyntheticMonitoringDashboard.vue?vue&type=script&lang=js&"
export * from "./SyntheticMonitoringDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports